module.exports = __webpack_public_path__ + "media/images/designer-10195b52f2d0c8286a68330f02752ef9.svg";